import { useState } from 'react'
import Brand from './Brand'
import './AuthForm.css'

// `askAccess` adds the shared access password field (invite-only signup); its
// value is passed to onSubmit as the third argument.
function AuthForm({ title, submitLabel, onSubmit, note, footer, askAccess = false }) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [access, setAccess] = useState('')
  const [error, setError] = useState('')
  const [submitting, setSubmitting] = useState(false)

  const handleSubmit = async (event) => {
    event.preventDefault()
    setError('')
    setSubmitting(true)
    try {
      await onSubmit(email, password, access)
    } catch (err) {
      setError(err.message)
      setSubmitting(false)
    }
  }

  return (
    <div className="auth">
      <form className="auth-card" onSubmit={handleSubmit}>
        <Brand />
        <h1 className="auth-title">{title}</h1>

        {error && <div className="auth-error">{error}</div>}

        <label className="auth-label">
          Email
          <input
            className="auth-input"
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            required
            autoComplete="email"
          />
        </label>

        <label className="auth-label">
          Password
          <input
            className="auth-input"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
            autoComplete="current-password"
          />
        </label>

        {note && <p className="auth-note">{note}</p>}

        {askAccess && (
          <label className="auth-label">
            Access password
            <input
              className="auth-input"
              type="password"
              value={access}
              onChange={(event) => setAccess(event.target.value)}
              required
              autoComplete="off"
            />
            <span className="auth-note">Codetalk is invite-only. Ask your team for this.</span>
          </label>
        )}

        <button className="auth-submit" type="submit" disabled={submitting}>
          {submitting ? 'Please wait...' : submitLabel}
        </button>

        <div className="auth-footer">{footer}</div>
      </form>
    </div>
  )
}

export default AuthForm
